import { Injectable } from '@angular/core';

/** 国旗比例：4x3 长方形；1x1 正方形（圆形国旗用） */
export type FlagShape = '4x3' | '1x1';

/**
 * 语系对应的国旗，值为 ISO 3166-1 alpha-2 小写代码（即 flag-icons 档名）。
 * 未列出的语系：代码带地区（如 fr-ca）时取地区，否则显示未知旗帜。
 */
const LANGUAGE_FLAGS: Record<string, string> = {
  'zh-cn': 'cn',
  'en-us': 'gb',
  th: 'th',
  vi: 'vn',
  tr: 'tr',
  'pt-br': 'br',
  ja: 'jp',
  de: 'de',
  es: 'es',
};

/** flag-icons 的未知旗帜 */
const UNKNOWN_FLAG = 'xx';

/** flag-icons 国旗 SVG 由 angular.json 从 node_modules 复制到此目录 */
const FLAGS_PATH = 'assets/flags';

@Injectable({
  providedIn: 'root',
})
export class CountryUtilsService {
  /**
   * 获取语系对应的国旗图片路径
   *
   * @param lang 语系
   * @param shape 国旗比例
   * @returns 图片路径
   */
  getLanguageFlag(lang: string, shape: FlagShape = '4x3'): string {
    const code = (lang || '').toLowerCase();
    const flag = LANGUAGE_FLAGS[code] ?? /^[a-z]{2,3}-([a-z]{2})$/.exec(code)?.[1] ?? UNKNOWN_FLAG;
    return `${FLAGS_PATH}/${shape}/${flag}.svg`;
  }
}
